import { Typography } from "@mui/material"
import { useState } from "react"
import { removeAccount } from "../../api"
import Modal from "../ui/Modal"
import { useSnackbar } from "notistack"

const DeleteAccount = (props) => {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const deleteAccount = () => {
    setLoading(true)
    removeAccount(props.data?.id)
      .then(() => {
        enqueueSnackbar("Account Deleted", { variant: "success" })
        props.refresh()
        props.close()
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }
  return (
    <Modal
      {...props}
      title="Delete Account"
      actionText="Delete"
      loading={loading}
      action={deleteAccount}
    >
      <Typography>
        Do you want to delete account '{props.data?.accountName}'? <br /> All
        material will be deleted.
      </Typography>
    </Modal>
  )
}

export default DeleteAccount
